import { LargeIcon } from '@favordelivery/tupperware/lib/components/icons/baseIcon'

export const Support = props => (
  <LargeIcon {...props}>
    <path
      d="M35.3206 7.80762C32.9165 7.80762 30.6649 8.76285 28.9134 10.4555L28.4862 10.8939L25.1691 14.5063C25.0776 14.6059 24.9205 14.6059 24.8291 14.5063L21.5124 10.8935C19.7085 8.92865 17.2833 7.80762 14.6789 7.80762C9.31442 7.80762 5 12.5566 5 18.3687C5 20.9798 5.86773 23.4333 7.41945 25.3512L7.82152 25.8194L23.9036 42.0858C24.5057 42.6948 25.4893 42.6949 26.0915 42.0859L42.1921 25.805C43.8468 23.9854 44.8392 21.5959 44.9821 19.0172L45 18.3687C45 12.5568 40.6852 7.80762 35.3206 7.80762Z"
      stroke="var(--primaryColor)"
      strokeWidth="4.12632"
    />
  </LargeIcon>
)

export default Support
